import {
  desserializarSessaoMesa,
  sessaoDaCena,
  type SessaoMesa,
} from '../../../dominio/tabletop/sessao'
import { PRESETS_MESA } from '../../../dominio/tabletop/presets'

export const CHAVE_MESA = 'qbrn-lab-mesa-v1'

export function carregarMesa(): { sessao: SessaoMesa; erro: string } {
  try {
    const json = window.localStorage.getItem(CHAVE_MESA)
    return {
      sessao: json
        ? desserializarSessaoMesa(json)
        : sessaoDaCena(PRESETS_MESA[0]!.cena),
      erro: '',
    }
  } catch {
    return {
      sessao: sessaoDaCena(PRESETS_MESA[0]!.cena),
      erro: 'Não foi possível recuperar a mesa salva. Importe uma cópia JSON para recuperá-la.',
    }
  }
}

export function baixarArquivo(
  conteudo: string,
  nome: string,
  tipo = 'application/json',
) {
  const url = URL.createObjectURL(new Blob([conteudo], { type: tipo }))
  const a = document.createElement('a')
  a.href = url
  a.download = nome
  a.click()
  setTimeout(() => URL.revokeObjectURL(url), 1000)
}
